export default ({
  byHour,
  hour,
}) => (
  byHour[hour] || []
)
